import { access, community } from '@/data';
import { ListHeaderItem, RequestData } from '@/components/common/list';
import changeTextByScene from '@/methods/setText';
import { AllowType } from './all.type';

changeTextByScene(community.ProjectType.value);

const requestData: {
    [key in AllowType]: RequestData
} = {
    self: {
        url: 'v2/getroomdevices',
        param: {
            ID: '',
            PID: ''
        }
    },
    common: {
        url: 'getppubdevice',
        param: {}
    }
};
const { repeatLabels, weekList } = access;

const getFormRules = (type: string) => {
    if (type === '0') {
        return {
            Name: [{
                required: true,
                message: WordList.RuleCommonLabelEmpty2.format(WordList.ProperAllTextAccessGroupName),
                trigger: 'blur'
            }],
            StartDay: [{
                type: 'date',
                required: true,
                message: WordList.RuleCommonLabelEmpty2.format(WordList.TabelTmpKeyInHtmlBeginTime),
                trigger: 'blur'
            }],
            StopDay: [{
                type: 'date',
                required: true,
                message: WordList.RuleCommonLabelEmpty2.format(WordList.TabelTmpKeyInHtmlEndTime),
                trigger: 'blur'
            }]
        };
    }

    return {
        Name: [{
            required: true,
            message: WordList.RuleCommonLabelEmpty2.format(WordList.ProperAllTextAccessGroupName),
            trigger: 'blur'
        }],
        StartTime: [{
            type: 'date',
            required: true,
            message: WordList.RuleCommonLabelEmpty2.format(WordList.TmpKeyListTanleBeginTime),
            trigger: 'blur'
        }],
        StopTime: [{
            type: 'date',
            required: true,
            message: WordList.RuleCommonLabelEmpty2.format(WordList.TabelTmpKeyInHtmlEndTime),
            trigger: 'blur'
        }]
    };
};

type ProjectDataType = {
    [key in ProjectType]: {
        header: Array<ListHeaderItem>;
    };
}
const getProjectData = () => {
    const communityHeader: Array<ListHeaderItem> = [{
        name: 'UnitName',
        label: WordList.ProperAllTextBuild
    }, {
        name: 'Location',
        label: WordList.ProperAllTextLocation
    }, {
        name: 'MAC',
        label: WordList.ProperAllTextMac
    }, {
        name: 'Status',
        label: WordList.ProperAllTextStatus,
        type: 'customize'
    }, {
        name: 'Type',
        label: WordList.RDeviceListTanleType,
        type: 'customize'
    }, {
        name: 'Relay',
        label: WordList.ProperAllTextRelay,
        type: 'customize',
        headerType: 'customize'
    }];
    const officeHeader: Array<ListHeaderItem> = [{
        name: 'UnitName',
        label: WordList.ProperAllTextDepartment
    }, {
        name: 'Location',
        label: WordList.ProperAllTextLocation
    }, {
        name: 'MAC',
        label: WordList.ProperAllTextMac
    }, {
        name: 'Status',
        label: WordList.ProperAllTextStatus,
        type: 'customize'
    }, {
        name: 'Type',
        label: WordList.RDeviceListTanleType,
        type: 'customize'
    }, {
        name: 'Relay',
        label: WordList.ProperAllTextRelay,
        type: 'customize',
        headerType: 'customize'
    }];
    const projectData: ProjectDataType = {
        community: {
            header: communityHeader
        },
        office: {
            header: officeHeader
        }
    };
    return projectData;
};
export default null;

export {
    requestData,
    repeatLabels,
    weekList,
    getFormRules,
    getProjectData
};